import type { StatusRef } from '../types/phoneNumber.types'

const COLOR_BY_DISPLAY: Record<string, string> = {
  active: 'green',
  'pending port': 'blue',
  porting: 'purple',
  foc: 'blue',
  'port rejected': 'orange',
  'ported out': 'gray',
  canceled: 'red',
  deleted: 'red',
  inactive: 'orange',
  suspended: 'orange',
  disconnected: 'red',
  reserved: 'gray',
  pending: 'blue',
}

export function getStatusColorPalette(
  status: StatusRef | string | undefined | null,
): string {
  if (!status) return 'gray'
  const display = typeof status === 'string' ? status : status.display
  return COLOR_BY_DISPLAY[display.toLowerCase()] ?? 'gray'
}
